const createErrorObject = (type = "validation", message, path) => ({
  type,
  message: message.replace(/['"]/g, ""),
  path,
});

const handleSingleFieldError = (errors, path, type, message) => {
  errors[path[0]] = createErrorObject(type, message, path);
};

const handleNestedObjectError = (errors, path, type, message) => {
  const [objectName, fieldName] = path;
  if (!errors[objectName]) errors[objectName] = {};
  errors[objectName][fieldName] = createErrorObject(type, message, path);
};

const handleArrayFieldError = (errors, path, type, message) => {
  const [arrayName, index, arrayField] = path;
  if (!errors[arrayName]) errors[arrayName] = [];
  if (!errors[arrayName][index]) errors[arrayName][index] = {};
  errors[arrayName][index][arrayField] = createErrorObject(type, message, path);
};

const handleDeepNestedError = (errors, path, type, message) => {
  let current = errors;
  path.forEach((key, i) => {
    if (i === path.length - 1) {
      current[key] = createErrorObject(type, message, path);
    } else {
      current[key] = current[key] || {};
      current = current[key];
    }
  });
};

const handleValidationError = (errors, { path, type, message }) => {
  const errorHandlers = {
    1: handleSingleFieldError,
    2: handleNestedObjectError,
    3: handleArrayFieldError,
    default: handleDeepNestedError,
  };

  const handler = errorHandlers[path.length] || errorHandlers.default;
  handleDeepNestedError(errors, path, type, message);
};

export const joiResolver = (schema) => async (data) => {
  try {
    const values = await schema.validateAsync(data, {
      abortEarly: false,
      allowUnknown: true,
    });
    
    return { values, errors: {} };
  } catch (errors) {
    if (!errors.details) {
      return {
        values: {},
        errors: { "": { message: "Validation failed" } },
      };
    }

    const formErrors = {};

    errors.details.forEach((error) => handleValidationError(formErrors, error));
    console.log("joiResolve", errors.details, formErrors);

    return { values: {}, errors: formErrors };
  }
};

export const exportAllErrorFields = (errors) => {
  const fields = [];
  const stack = [errors]; // Initialize stack with the root object
  // console.log("exportAllErrorFields", errors);

  while (stack.length > 0) {
    const current = stack.pop(); // Get the last item from the stack

    for (const key in current) {
      if (Array.isArray(current[key])) {
        // If it's an array, push its items onto the stack
        current[key].forEach((item) => stack.push(item));
      } else if (typeof current[key] === "object" && current[key] !== null) {
        // If it's an object, check for a message
        if (current[key].path) {
          fields.push(current[key].path.join("."));
        }
        stack.push(current[key]); // Push the object onto the stack for further processing
      }
    }
  }

  return fields;
};
